import { GlSprintf, GlLink } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { __ } from '~/locale';
export default {
    name: 'DesignNoteSignedOut',
    components: {
        GlSprintf,
        GlLink
    },
    props: {
        registerPath: {
            type: String,
            required: true
        },
        signInPath: {
            type: String,
            required: true
        },
        isAddDiscussion: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        signedOutText () {
            return this.isAddDiscussion ? __('Please %{registerLinkStart}register%{registerLinkEnd} or %{signInLinkStart}sign in%{signInLinkEnd} to start a new discussion.') : __('Please %{registerLinkStart}register%{registerLinkEnd} or %{signInLinkStart}sign in%{signInLinkEnd} to reply.');
        }
    }
};
